module.exports = __webpack_public_path__ + "img/poster8-sub2.941f282d.png";